module.exports = __webpack_public_path__ + "static/media/num_chart_widget_icon.99499fdc.svg";